/**
 * Printem quote bag — persistent multi-line decoration brief (localStorage).
 * Key: printem_quote_v1
 * Events: printem:quote-changed (CustomEvent on window/document)
 */
(function (global) {
  'use strict';

  var STORAGE_KEY = 'printem_quote_v1';
  var VERSION = 1;

  function emptyBag() {
    return {
      version: VERSION,
      lines: [],
      branding: {
        notes: '',
        deadline: '',
        company: ''
      },
      contact: {
        name: '',
        email: '',
        phone: '',
        company: ''
      },
      updatedAt: null
    };
  }

  function uid() {
    return 'ql_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 9);
  }

  function safeParse(raw) {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function normalize(bag) {
    if (!bag || typeof bag !== 'object') return emptyBag();
    if (!Array.isArray(bag.lines)) bag.lines = [];
    bag.branding = bag.branding || { notes: '', deadline: '', company: '' };
    bag.contact = bag.contact || { name: '', email: '', phone: '', company: '' };
    bag.version = VERSION;
    return bag;
  }

  function get() {
    try {
      var raw = global.localStorage.getItem(STORAGE_KEY);
      if (!raw) return emptyBag();
      return normalize(safeParse(raw));
    } catch (e) {
      return emptyBag();
    }
  }

  function set(bag) {
    var next = normalize(bag);
    next.updatedAt = new Date().toISOString();
    try {
      global.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (e) {
      /* quota / private mode */
    }
    fire(next);
    return next;
  }

  function fire(bag) {
    var detail = { bag: bag, count: (bag.lines || []).length };
    try {
      var ev = new CustomEvent('printem:quote-changed', { detail: detail, bubbles: true });
      global.dispatchEvent(ev);
      if (global.document) global.document.dispatchEvent(ev);
    } catch (e) {
      /* IE / old */
    }
  }

  function add(line) {
    var bag = get();
    var entry = {
      id: line.id || uid(),
      handle: line.handle || '',
      title: line.title || '',
      colour: line.colour || line.color || '',
      size: line.size || '',
      qty: line.qty != null ? Number(line.qty) || 1 : 1,
      method: line.method || '',
      placements: Array.isArray(line.placements) ? line.placements.slice() : [],
      notes: line.notes || '',
      image: line.image || '',
      url: line.url || '',
      addedAt: line.addedAt || new Date().toISOString()
    };
    bag.lines.push(entry);
    set(bag);
    return entry;
  }

  function update(id, patch) {
    var bag = get();
    var found = null;
    bag.lines = bag.lines.map(function (line) {
      if (line.id !== id) return line;
      found = Object.assign({}, line, patch || {}, { id: line.id });
      if (patch && patch.placements) {
        found.placements = Array.isArray(patch.placements) ? patch.placements.slice() : line.placements;
      }
      return found;
    });
    set(bag);
    return found;
  }

  function remove(id) {
    var bag = get();
    var before = bag.lines.length;
    bag.lines = bag.lines.filter(function (line) {
      return line.id !== id;
    });
    set(bag);
    return before !== bag.lines.length;
  }

  function clear() {
    var bag = emptyBag();
    set(bag);
    return bag;
  }

  function count() {
    return get().lines.length;
  }

  function setBranding(partial) {
    var bag = get();
    bag.branding = Object.assign({}, bag.branding, partial || {});
    return set(bag);
  }

  function setContact(partial) {
    var bag = get();
    bag.contact = Object.assign({}, bag.contact, partial || {});
    return set(bag);
  }

  function summaryText() {
    var bag = get();
    var lines = bag.lines || [];
    if (!lines.length) return 'No lines in quote bag.';
    var parts = ['Printem quote bag (' + lines.length + ' line' + (lines.length === 1 ? '' : 's') + ')'];
    lines.forEach(function (line, i) {
      parts.push('');
      parts.push((i + 1) + '. ' + (line.title || line.handle || 'Item'));
      if (line.handle) parts.push('   Handle: ' + line.handle);
      if (line.colour) parts.push('   Colour: ' + line.colour);
      if (line.size) parts.push('   Size: ' + line.size);
      parts.push('   Qty: ' + (line.qty || 1));
      if (line.method) parts.push('   Method: ' + line.method);
      if (line.placements && line.placements.length) {
        parts.push('   Placements: ' + line.placements.join(', '));
      }
      if (line.notes) parts.push('   Notes: ' + line.notes);
      if (line.url) parts.push('   URL: ' + line.url);
    });
    if (bag.branding) {
      if (bag.branding.company) parts.push('', 'Shared company: ' + bag.branding.company);
      if (bag.branding.deadline) parts.push('Deadline: ' + bag.branding.deadline);
      if (bag.branding.notes) parts.push('Branding notes: ' + bag.branding.notes);
    }
    return parts.join('\n');
  }

  var api = {
    STORAGE_KEY: STORAGE_KEY,
    get: get,
    set: set,
    add: add,
    update: update,
    remove: remove,
    clear: clear,
    count: count,
    setBranding: setBranding,
    setContact: setContact,
    summaryText: summaryText,
    emptyBag: emptyBag
  };

  global.PrintemQuoteBag = api;
})(typeof window !== 'undefined' ? window : this);
